import styled from "styled-components";

export const V3SidebarPanelSpacer = styled.div`
    margin-bottom: 32px;
`;